import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. Component lives in `index.lazy.tsx` so the
// sources bundle (forms, dialog, sheet, schema validation) loads on
// demand.
export const Route = createFileRoute("/app/sources/")({});
